import { unitSearch } from "common/api/citajteo/dl_unit/citajteo_unit";
import { MAX_UNITS_EXCEL_EXPORT } from "constant/dl_unit/dl_unit.constant";
import {
  UNIT_FIELD_HM_VAL_NAMES,
  UnitFieldValName,
} from "constant/dl_unit/dl_unit_field.constant";
import { SEARCH_NAMES } from "constant/search/search";
import * as XLSX from "xlsx";

export const exportUnitExcelFile = async (
  unitSearchParams: Partial<Record<string, string | number | boolean>>,
  filename: string = "export",
): Promise<void> => {
  // 1. Prepare the data as an array of objects
  const worksheetData = [];

  const unitRes = await unitSearch({
    ...unitSearchParams,
    [SEARCH_NAMES.LIMIT]: MAX_UNITS_EXCEL_EXPORT,
  });
  console.log("unitSearch unitRes", unitRes);

  if (unitRes?.items) {
    for (let i = 0; i < unitRes.items.length; i++) {
      const unit = unitRes.items[i];
      const uType = unit.uType;
      const slug = unit.slug;
      const unitFieldVal: { [key: UnitFieldValName]: string } = {};
      for (let j = 0; j < UNIT_FIELD_HM_VAL_NAMES.length; j++) {
        const fName = UNIT_FIELD_HM_VAL_NAMES[j];
        unitFieldVal[fName] = unit.fValGet(fName);
      }

      const unitData = { slug, uType, ...unitFieldVal };
      worksheetData.push(unitData);
    }
  }

  // 2. Create a new workbook
  const workbook = XLSX.utils.book_new();

  // 3. Convert data to worksheet
  const worksheet = XLSX.utils.json_to_sheet(worksheetData);

  // 4. Append worksheet to workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // 5. Generate Excel file and trigger download
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};
